export default "__VITE_ASSET__OQItEXMu__"